export default "__VITE_ASSET__BsxnqtrW__"